module.exports = __webpack_public_path__ + "media/images/logo-addsecure-bbeba6e086c96b4f92b5a5eda463ec71.png";